import NavBar from "../../components/landing2/NavBar";
import Footer from "../../components/landing2/Footer";
import LandingOne from "../../components/landing2/LandingOne";
import StatsSection from "../../components/landing2/StatsSection";
import PowerUpFeatures from "../../components/landing2/PowerUpSection";
import ExploreMoreSection from "../../components/landing2/ExploreMoreSection";
import ContactSection from "../../components/landing2/ContactSection";
import InterestedSection from "../../components/landing2/InterestedSection";
import { useEffect } from "react";
import { Grid, Stack } from "@mui/material";

const Landing2 = () => {
  useEffect(() => {
    document.title = "Majura - Move Freight, Not Paperwork";
  }, []);

  return (
    <div style={{ width: "100vw", height: "100%" }}>
      <Grid container spacing={0} style={{ width: "100%" }}>
        <Grid size={{ xs: 12 }}>
          <NavBar />

          <main>
            <Stack
              direction={"column"}
              spacing={{ xs: '100px', md: "150px" }}
              style={{ width: "100%" }}
            >
              <LandingOne />

              <section id={'stat-section'} style={{ width: "100%", display: "flex", gap: "50px", flexDirection: "column" }}>
                <StatsSection />

                <PowerUpFeatures />
              </section>

              <ExploreMoreSection />

              <ContactSection />

              <InterestedSection />
            </Stack>
          </main>

          <footer>
            <Footer />
          </footer>
        </Grid>
      </Grid>
    </div>
  );
};

export default Landing2;
